// WIP

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ErrorWrapper from 'dpl/form/components/ErrorWrapper';
import Icon from 'dpl/common/components/Icon';

export default function GenericSelect({
  name,
  value,
  onChange,
  placeholder,
  options,
  className,
  id,
  errors,
  displayErrors,
  arrowClassName,
  disablePlaceholder,
  arrowSize,
  disabled
}) {
  return (
    <div
      className={classnames('DSGenericSelect relative overflow-hidden w-100', {
        pointer: !disabled
      })}
    >
      <div className="relative">
        <ErrorWrapper errors={errors} isShown={displayErrors}>
          <select
            id={id}
            name={name}
            value={value || ''}
            onChange={onChange}
            className={classnames(
              'pointer w-100 input-reset ba br3 b--default pl4 pr8 pt3 pb3 font-16 secondary bg-white',
              className,
              {
                disabled: !value
              }
            )}
            disabled={disabled}
            data-test-id={id}
          >
            <>
              <option value="" disabled={disablePlaceholder}>
                {placeholder}
              </option>
              {options.map(option => {
                if (typeof option === 'string') {
                  option = { value: option, title: option };
                }

                return (
                  <option
                    value={option.value || option.id}
                    key={option.value || option.id}
                    disabled={option.disabled}
                  >
                    {option.title || option.name}
                  </option>
                );
              })}
            </>
          </select>
        </ErrorWrapper>
        {!disabled && (
          <span
            className="mr2 z-3 pointer-events-none transform-center right-0 secondary"
            style={{ top: arrowSize }}
          >
            <Icon
              className={arrowClassName}
              name="fetch-chevron-down"
              width={arrowSize}
              height={arrowSize}
            />
          </span>
        )}
      </div>
    </div>
  );
}

GenericSelect.defaultProps = {
  name: null,
  className: '',
  placeholder: 'Select',
  value: null,
  id: null,
  errors: [],
  displayErrors: false,
  arrowClassName: '',
  disablePlaceholder: false,
  arrowSize: '24px',
  disabled: false
};

GenericSelect.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date)
  ]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        value: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
          PropTypes.instanceOf(Date)
        ]),
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        title: PropTypes.string,
        disabled: PropTypes.bool
      }),
      PropTypes.string
    ])
  ).isRequired,
  displayErrors: PropTypes.bool,
  arrowClassName: PropTypes.string,
  disablePlaceholder: PropTypes.bool,
  arrowSize: PropTypes.string,
  disabled: PropTypes.bool
};
